// The top-level fields of `next` that differ from `prev`, for a merge write that saves only what changed. Settings and
// the compass load once at sign-in with no listener, so writing the whole document would put this device's copy of
// every other field over one changed on another device. `skip` lists fields that have their own writes.
export const changedFields = (prev, next, skip = []) => Object.fromEntries(
  Object.entries(next || {}).filter(([key, value]) => !skip.includes(key) && JSON.stringify(value) !== JSON.stringify(prev?.[key]))
);
